import { Dialog, Transition } from '@headlessui/react';
import { XCircleIcon } from '@heroicons/react/24/solid';
import { Fragment, useState } from 'react';

export const GiftCardLocal = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
      <>
          <div className="product-similarGifts">
              <h2 className="md:hidden">How local gift cards work</h2>
              <div className="product-similarGifts-content">
                  <div className="product-similarGifts-list md:max-w-[400px]">
                      <h2 className="hidden md:block">
                          How local gift cards work
                      </h2>
                      <div className="product-similarGifts-item">
                          <span className="bg-[#ED1765]">1</span>
                          <div>
                              <strong>Search</strong> for a favorite local
                              spot—coffee, salons, <em>even auto shops.</em>
                          </div>
                      </div>
                      <div className="product-similarGifts-item">
                          <span className="bg-[#6CC6B1]">2</span>
                          <div>
                              <strong>Pick</strong> an amount and who it's for.
                          </div>
                      </div>
                      <div className="product-similarGifts-item">
                          <span className="bg-[#F58320]">3</span>
                          <div>
                              <strong>Send</strong> instantly by text or email.
                          </div>
                      </div>
                      <div className="product-similarGifts-item">
                          <span className="bg-[#FAC840]">4</span>
                          <div>
                              <strong>Recipient</strong> taps to use their
                              digital card. Details.
                          </div>
                      </div>
                  </div>
                  <div className="product-similarGifts-video relative">
                      <img
                          src="/bg-video.svg"
                          alt="How it works video"
                          className="w-full h-full object-cover max-w-[520px] mx-auto"
                      />
                      <button
                          onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              setIsOpen(true);
                          }}
                          className="product-similarGifts-video-play absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 p-3 rounded-full shadow-lg"
                      >
                          <img src="/play.svg" alt="Play Button" />
                      </button>
                  </div>
              </div>
          </div>

          <Transition appear show={isOpen} as={Fragment}>
              <Dialog
                  as="div"
                  className="relative z-[99999]"
                  onClose={() => {
                      setIsOpen(false);
                  }}
              >
                  <Transition.Child
                      as={Fragment}
                      enter="ease-out duration-300"
                      enterFrom="opacity-0"
                      enterTo="opacity-100"
                      leave="ease-in duration-200"
                      leaveFrom="opacity-100"
                      leaveTo="opacity-0"
                  >
                      <div className="fixed inset-0 bg-black/25" />
                  </Transition.Child>

                  <div className="fixed inset-0 overflow-y-auto">
                      <div className="flex min-h-full items-center justify-center p-4 text-center">
                          <Transition.Child
                              as={Fragment}
                              enter="ease-out duration-300"
                              enterFrom="opacity-0 scale-95"
                              enterTo="opacity-100 scale-100"
                              leave="ease-in duration-200"
                              leaveFrom="opacity-100 scale-100"
                              leaveTo="opacity-0 scale-95"
                          >
                              <Dialog.Panel className="relative w-full max-w-[420px] mx-auto transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl">
                                  <Dialog.Title
                                      as="h3"
                                      className="flex justify-end -mt-4 -mr-2"
                                  >
                                      <button
                                          onClick={() => setIsOpen(false)}
                                          aria-label="Close Modal"
                                      >
                                          <XCircleIcon className="h-6 w-6 ml-2" />
                                      </button>
                                  </Dialog.Title>
                                  <div className="w-full">
                                      <div className="relative w-full aspect-[9/16] max-h-[90vh] z-[999999]">
                                          <iframe
                                              className="absolute top-0 left-0 w-full h-full"
                                              src="https://www.youtube.com/embed/gjGnAPOL0AI?controls=1&rel=0&autoplay=1"
                                              title="YouTube video player"
                                              frameBorder="0"
                                              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                              allowFullScreen
                                          ></iframe>
                                      </div>
                                  </div>
                              </Dialog.Panel>
                          </Transition.Child>
                      </div>
                  </div>
              </Dialog>
          </Transition>
      </>
  );
};